import { render, staticRenderFns } from "./AsidePanel.vue?vue&type=template&id=5dfd50f6&scoped=true"
import script from "./AsidePanel.vue?vue&type=script&lang=js"
export * from "./AsidePanel.vue?vue&type=script&lang=js"
import style0 from "./AsidePanel.vue?vue&type=style&index=0&id=5dfd50f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfd50f6",
  null
  
)

export default component.exports